module.exports = __webpack_public_path__ + "img/HomePage-manufacturing-firms.9426f02.webp";